import React from 'react';

export interface JcCardProps {
  as?: 'div' | 'section' | 'li';
  className?: string;
  children: React.ReactNode;
}

/**
 * Shared elevated card shell for the earth-tone design language (job detail V2's
 * rounded-[24px] treatment), extended to best-companies / company profile / salary pages so
 * they stop each hand-rolling the same radius/shadow/border combination.
 */
export function JcCard({ as = 'div', className = '', children }: JcCardProps) {
  const Tag = as;
  return (
    <Tag
      className={`rounded-[24px] border border-jc-card-border bg-jc-surface shadow-[0_1px_3px_rgba(22,21,15,0.08)] dark:shadow-[0_1px_3px_rgba(0,0,0,0.35)] ${className}`}
    >
      {children}
    </Tag>
  );
}
